// Shared hub wrapper — console-standard. Wraps in ConsoleShell (dark/light, full-
// bleed, toggle) and renders the SELECTED child screen as a clickable sub-tab.
// Children render EMBEDDED so they inherit the hub's theme instead of nesting
// their own shells (ConsoleShell auto-detects nesting and passes through).
import React, { useState, useEffect } from 'react';
import { ConsoleShell, useConsoleTheme, F } from '../components/Console';
import HubOverview from '../components/HubOverview';

function HubBody({ tabs, passProps, hubId, title }) {
  const { t } = useConsoleTheme();
  const hubKey = hubId || title || 'x';
  const key = 'cc_hub_tab_' + hubKey;
  const [active, setActive] = useState(() => {
    try { return localStorage.getItem(key) || tabs[0].id; } catch (_e) { return tabs[0].id; }
  });
  const cur = tabs.find(tb => tb.id === active) || tabs[0];
  const { Component } = cur;
  const select = (id) => { setActive(id); try { localStorage.setItem(key, id); } catch (_e) {} };
  // External tab switching: window.dispatchEvent(new CustomEvent('sanoire:hubtab',
  // { detail: { hub: '<hubId-or-title>', tab: '<tabId>' } }))
  useEffect(() => {
    const onTab = (e) => {
      const d = (e && e.detail) || {};
      if (d.hub === hubKey && d.tab && tabs.some(tb => tb.id === d.tab)) select(d.tab);
    };
    window.addEventListener('sanoire:hubtab', onTab);
    return () => window.removeEventListener('sanoire:hubtab', onTab);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hubKey, tabs]);

  return (
    <div>
      {hubId && <HubOverview hubId={hubId} />}
      <div style={{ display:'flex', gap:2, flexWrap:'wrap', borderBottom:`1px solid ${t.bd}`, marginBottom:20 }}>
        {tabs.map(tb => {
          const on = tb.id === cur.id;
          return (
            <button key={tb.id} onClick={() => select(tb.id)}
              style={{ appearance:'none', background:'transparent', border:'none', cursor:'pointer',
                fontFamily:F, fontSize:'0.95rem', fontWeight: on ? 600 : 500,
                color: on ? t.tx : t.mut, padding:'9px 15px 11px', marginBottom:-1,
                borderBottom: on ? `2px solid ${t.accent}` : '2px solid transparent',
                display:'inline-flex', alignItems:'center', gap:7, transition:'color .12s' }}>
              {tb.label}
              {tb.badge ? (
                <span style={{ fontSize:'0.66rem', fontWeight:700, color:'#fff', background: tb.bc || t.danger,
                  borderRadius:99, padding:'1px 7px', lineHeight:1.5 }}>{tb.badge}</span>
              ) : null}
            </button>
          );
        })}
      </div>
      <div key={cur.id}>
        <Component {...(passProps || {})} embed={true} />
      </div>
    </div>
  );
}

export default function HubScreen({ tabs, passProps, hubId, title }) {
  const shellTitle = title || (hubId ? hubId.charAt(0).toUpperCase() + hubId.slice(1) : 'Hub');
  return (
    <ConsoleShell title={shellTitle}>
      <HubBody tabs={tabs} passProps={passProps} hubId={hubId} title={title} />
    </ConsoleShell>
  );
}
